import { useQuery } from '@tanstack/react-query'
import publicHttp from '../../utils/Http/PublicHttp'

export type CheckoutSessionUserResponse = {
	email: string
	phone_number: string
	name: string
	product_name: string
	next_payment_date: string
	status: string
	existing_user: boolean
	firstName: string
	lastName: string
	remaining_daily_calls: number
	remaining_monthly_calls: number
	active_subscription: boolean
	user_id: string
}

export const getUserByCheckoutSessionId = async (checkoutSessionId: string): Promise<CheckoutSessionUserResponse> => {
	console.log('Making API call with session ID:', checkoutSessionId) // Debug log
	try {
		const response = await publicHttp({
			url: '/onboarding/get_user_by_checkout_session_id',
			method: 'get',
			params: {
				stripe_checkout_session_id: checkoutSessionId,
			},
		})
		console.log('API Response:', response.data) // Debug response
		return response.data
	} catch (error) {
		console.error('API Error:', error) // Debug any errors
		throw error
	}
}

export default function useFetchUserByCheckoutSessionId(sessionId: string | null) {
	console.log('Hook called with sessionId:', sessionId) // Debug hook parameter
	return useQuery({
		queryKey: ['checkout_session_user', sessionId],
		queryFn: () => getUserByCheckoutSessionId(sessionId as string),
		enabled: !!sessionId,
		// Only retry the request twice after the initial attempt (total of 3 tries).
		retry: 2,
		// Do not automatically refetch when the component remounts or the window regains focus.
		refetchOnMount: false,
		refetchOnWindowFocus: false,
	})
}
